export default __webpack_public_path__ + "media/devise/devise-banner-img-a081d698.png";